import { ChangeMileageValidatorErrors } from '../types';

export const defaultChangeMileageError: ChangeMileageValidatorErrors = {
    newMileageAmount: {
        sameAsPrevious: 'Mileage amount must be changed',
    },
};
